import { Avatar, Grid, Typography } from "@mui/material";
import { AppImages } from "app/appImages";
import { MprcLink } from "components";
import { MprcContainer } from "components/MprcContainer";
import { UserEditProfileResponse } from "generated/CoreApi_v1";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { EditUserPersonalInterest } from "views/foundation/user/Home/EditProfile/EditUserPersonalInterest";
import { EditUserCredentials } from "views/foundation/user/Home/EditUser/EditUserCredentials";
import { EditUserTopics } from "views/foundation/user/Home/EditUser/EditUserTopics";
import { EditUserIdiomProficiency } from "../EditUser/EditUserIdiomProficiency";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    viewData: UserEditProfileResponse;
    onSubForm: (subform: any) => void;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Perfil de Usuário - Interesses do usuário
 * @param props
 */
export const EditUserInterestBox: React.FC<IProps> = (props) => {
    ///////////////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const { viewData, onSubForm } = props;
    const [dialog, setDialog] = useState<any>();

    ////////////////////////////////////////////////////////////////////////////

    const handleOption = (option: "topics" | "curriculum" | "proficience" | "personal") => () => {
        switch (option) {
            case "topics": onSubForm(<EditUserTopics userId={viewData.userId} userName={viewData.name} editMode="profile" onClose={() => onSubForm(null)} />);
                break;
            case "personal": onSubForm(<EditUserPersonalInterest userId={viewData.userId} name={viewData.name} onClose={() => onSubForm(null)} />);
                break;
            case "curriculum": onSubForm(<EditUserCredentials userId={viewData.userId} userName={viewData.name} editMode="profile" onClose={() => onSubForm(null)} />);
                break;
            case "proficience": setDialog(<EditUserIdiomProficiency userId={viewData.userId} userName={viewData.name} readonly={!viewData.permissions.allowUpdatePersonal} onClose={() => setDialog(null)} />);
                break;
        }
    };

    const RenderImage = (src: string) => {
        return <Avatar variant="rounded" src={src} sx={{ width: "100%", height: "127px" }} />;
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            {dialog}
            <MprcContainer>
                <Grid container spacing={2}>
                    <Grid>
                        <Grid container spacing={2}>
                            <Grid>
                                <MprcLink onClick={handleOption("topics")}>
                                    {RenderImage(AppImages.UserProfileProfessionalInterest)}
                                </MprcLink>
                            </Grid>
                            <Grid size="grow">
                                <MprcLink onClick={handleOption("topics")}>
                                    <Typography variant="h3" color="info.main">{t("User.Edit.Interest.ProfessionalTitle")}</Typography>
                                </MprcLink>
                                <Typography variant="caption" component="p">
                                    {t("User.Edit.Interest.ProfessionalL1")}<br />
                                    {t("User.Edit.Interest.ProfessionalL2")}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid>
                        <Grid container spacing={2}>
                            <Grid>
                                <MprcLink onClick={handleOption("curriculum")}>
                                    {RenderImage(AppImages.UserProfileCurriculum)}
                                </MprcLink>
                            </Grid>
                            <Grid size="grow">
                                <MprcLink onClick={handleOption("curriculum")}>
                                    <Typography variant="h3" color="info.main">{t("User.Edit.Interest.CurriculumTitle")}</Typography>
                                </MprcLink>
                                <Typography variant="caption" component="p">
                                    {t("User.Edit.Interest.CurriculumL1")}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid>
                        <Grid container spacing={2}>
                            <Grid>
                                <MprcLink onClick={handleOption("proficience")}>
                                    {RenderImage(AppImages.UserProfileProficience)}
                                </MprcLink>
                            </Grid>
                            <Grid size="grow">
                                <MprcLink onClick={handleOption("proficience")}><Typography variant="h3" color="info.main">{t("User.Edit.Interest.ProficienceTitle")}</Typography></MprcLink>
                                <Typography variant="caption" component="p">
                                    {t("User.Edit.Interest.ProficienceL1")}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid>
                        <Grid container spacing={2}>
                            <Grid>
                                <MprcLink onClick={handleOption("personal")}>
                                    {RenderImage(AppImages.UserProfilePersonalInterest)}
                                </MprcLink>
                            </Grid>
                            <Grid size="grow">
                                <MprcLink onClick={handleOption("personal")}><Typography variant="h3" color="info.main">{t("User.Edit.Interest.PersonalTitle")}</Typography></MprcLink>
                                <Typography variant="caption" component="p">
                                    {t("User.Edit.Interest.PersonalL1")}<br />
                                    {t("User.Edit.Interest.PersonalL2")}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </MprcContainer >
        </>
    );
};
